import React, { useState } from "react";
import inStore from "../../Assets/Images/p_appointment_inStore.svg";
import p_appointment_right_arrow from "../../Assets/Images/p_appointment_right_arrow.svg";
import doorstep from "../../Assets/Images/doorstepIcons.png"
import { FaStar } from "react-icons/fa";
import { FaArrowRightLong } from "react-icons/fa6";
import './appointmentCards.css';
const AppointmentProductCard = (product) => {
    const [data, setData] = useState(product?.data)
    // console.log("AppointmentProductCard", data);

    return (
        <>
            <div className="appointmentCard position-relative p-0" >
                <div className="appointmentCardInner">
                    {
                        data?.shipping_type == '0' ? (
                            <div className="dineIn position-absolute">
                                <img
                                    src={inStore}
                                    width={'14px'} height={'14px'}
                                />
                                <div className="ff-poppins-regular fs-12">
                                    Dine-in
                                </div>
                            </div>
                        ) :
                            data?.shipping_type == '1' ? (
                                <div className="service position-absolute">
                                    <img
                                        src={inStore}
                                        width={'14px'} height={'14px'}
                                    />
                                    <div className="ff-poppins-regular fs-12">
                                        In-Store
                                    </div>
                                </div>
                            ) : (
                                <div className="doorstep position-absolute">
                                    <img
                                        src={doorstep}
                                        width="12px"
                                        height="12px"

                                    />
                                    <div className="ff-poppins-regular fs-12">
                                        Doorstep
                                    </div>
                                </div>
                            )}
                    {
                        data?.pre_order_status == 1 &&
                        <div className="preOrder position-absolute">
                            <div className="ff-poppins-regular fs-12">
                                Pre-order
                            </div>
                        </div>
                    }
                    <div className="d-flex">
                        <div className="position-relative">
                            <img src={data?.vendor_detail?.vendor_logo} className="order-card-image" />
                            {(() => {
                                // overall state (order_status) combined with the stage (delivery_status)
                                const orderStatus = String(data?.order_status ?? "");
                                const deliveryStatus = String(data?.delivery_status ?? "");
                                let badge = null;
                                if (orderStatus === "3") badge = { text: "CANCELLED", color: "#f43b51" };
                                else if (orderStatus === "2" || deliveryStatus === "5") badge = { text: "COMPLETED", color: "#727374" };
                                else if (orderStatus === "1" && ["2", "3", "4"].includes(deliveryStatus)) badge = { text: "IN PROGRESS", color: "#DFBE17" };
                                else if (orderStatus === "1") badge = { text: "YET TO START", color: "#68a801" };
                                else if (orderStatus === "") badge = { text: "YET TO PAY", color: "#FFA500" };
                                return badge ? (
                                    <div className="status  d-flex justify-content-center align-items-center text-white ff-poppins-semiBold fs-10 position-absolute" style={{ backgroundColor: badge.color }}>{badge.text}</div>
                                ) : <></>;
                            })()}

                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 ms-3 ps-2">
                            <div>
                                <div className="ff-poppins-semiBold singleline-text fs-14">
                                    {data?.vendor_detail?.vendor_company_name}
                                </div>
                                <div className="ff-poppins-regular fs-10">
                                    MID-{data?.vendor_detail?.vendor_id}
                                </div>
                                <div className="ff-poppins-regular fs-10 ff-poppins-semiBold">
                                    {data?.order_date_string}
                                </div>
                                <div className="ff-poppins-regular fs-10 singleline-text">
                                    {data?.order_products &&
                                        (data.pre_order_status == 1 ?
                                            data?.order_products?.ticket_name :
                                            Object.values(data.order_products)
                                                .map((obj) => obj?.product_name)
                                                .join(",")
                                        )}
                                </div>


                                {
                                    data?.delivery_status == "5" && data?.rating_status == false ?
                                        <div className="primary-text fs-11 d-flex">
                                            <div > Feedback Pending </div> <div className="ms-1"><FaArrowRightLong /></div>
                                        </div> : <></>
                                }
                            </div>

                            <div className="d-flex h-100 flex-column justify-content-evenly">
                                <div className="d-flex h-100 flex-column justify-content-evenly mt-4">
                                    <div className="d-flex justify-content-end">
                                        <img src={p_appointment_right_arrow} width="16px" height="16px" />
                                    </div>
                                    <div >
                                        {
                                            data?.rating_status == true ?
                                                <div className=' d-flex justify-content-end'>
                                                    <div className='rating '>
                                                        <div><span style={{ fontSize: '13px' }} className="d-flex flex-column align-items-center justify-content-center"> <FaStar className='star' /> </span></div>
                                                        <div className="ff-poppins-semiBold"><span style={{ fontSize: '11px' }}> {data?.rating_detail?.rate_count}</span></div>
                                                    </div>
                                                </div>
                                                : <></>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="primary-text ff-poppins-semiBold fs-9 px-2 py-1 mt-2 w-100 secondary-bg-1 productStatus d-flex justify-content-between"  >

                    <div>
                        {
                            data?.delivery_status == "0" ?
                                <span>Order status - Unconfirmed</span>
                                : data?.delivery_status == "1" ?
                                    <span>Order status - Not Ready</span>
                                    : data?.delivery_status == "2" ?
                                        <span>Order status - Ready</span>
                                        : data?.delivery_status == "3" ?
                                            <span>Order status - pickup</span>
                                            : data?.delivery_status == "4" ?
                                                <span>Order status - Delivery Location Reached</span>
                                                : data?.delivery_status == "5" ?
                                                    <span>Order status - Product Delivered</span>
                                                    : <></>

                        }
                    </div>
                    <div>
                        {
                            data?.delivery_staff_status == true && data?.shipping_type == 2 ?
                                <span className="">Delivery staff : Assigned</span>
                                :
                                data?.delivery_staff_status == false && data?.shipping_type == 2 && data?.delivery_status != "0" ?
                                    <span className="text-dark">Delivery staff : Not Assigned</span>
                                    : <></>
                        }
                    </div>
                </div>
            </div>


            {/* <div className="appointmentCard position-relative p-0" >
                <div className="appointmentCardInner">
                    {
                        data?.shipping_type &&
                        <div className={`order-card-badge ${data?.shipping_type == 0 ? 'order-card-badge-dinein' :
                            data?.shipping_type == 1 ? 'order-card-badge-instore' : 'order-card-badge-doorstep'}`}>
                            <img src={data?.shipping_type == 2 ? doorstep : inStore} width={'14px'} />
                            <div className="ff-poppins-regular fs-12">
                                {data?.shipping_type == 0 ? 'Dine-in' : data?.shipping_type == 1 ? 'In-Store' : 'Doorstep'}
                            </div>
                        </div>
                    }
                    {
                        data?.pre_order_status == 1 &&
                        <div className="order-card-badge-preorder">
                            <div className="ff-poppins-regular fs-12">
                                Pre-order
                            </div>
                        </div>
                    }



                    <div className="d-flex">


                        <img src={data?.vendor_detail?.vendor_logo} className="order-card-image" />



                        <div className={`order-card-status  
                            ${data?.order_status == 1 ? 'status-pending' :
                                data?.order_status == 2 ? 'status-completed' :
                                    data?.order_status == 3 ? 'status-cancelled' :
                                        'status-unpaid'
                            }
                            `}>
                            {data?.order_status == "1" ? 'YET TO START' : data?.order_status == "2" ? 'COMPLETED' : data?.order_status == "3" ? 'CANCELLED' : 'YET TO PAY'}
                        </div>




                        <div className="d-flex justify-content-between align-items-center w-100 ms-3 ps-2">
                            <div>
                                <div className="ff-poppins-semiBold singleline-text fs-16">
                                    {data?.vendor_detail?.vendor_company_name}
                                </div>
                                <div className="ff-poppins-regular fs-10">
                                    MID-{data?.vendor_detail?.vendor_id}
                                </div>
                                <div className="ff-poppins-regular fs-10 ff-poppins-semiBold">
                                    {data?.order_date_string}
                                </div>
                                <div className="ff-poppins-regular fs-10 singleline-text">
                                    {data?.order_products &&
                                        (data.pre_order_status == 1 ?
                                            data?.order_products?.ticket_name :
                                            Object.values(data.order_products)
                                                .map((obj) => obj?.product_name)
                                                .join(",")
                                        )}
                                </div>


                                {
                                    data?.delivery_status == "5" && data?.rating_status == false ?
                                        <div className="primary-text fs-11 d-flex">
                                            <div > Feedback Pending </div> <div className="ms-1"><FaArrowRightLong /></div>
                                        </div> : <></>
                                }
                            </div>

                            <div className="d-flex h-100 flex-column justify-content-evenly">
                                <div className="d-flex h-100 flex-column justify-content-evenly mt-4">
                                    <div className="d-flex justify-content-end">
                                        <img src={p_appointment_right_arrow} width="16px" height="16px" />
                                    </div>
                                    <div >
                                        {
                                            data?.rating_status == true ?
                                                <div className=' d-flex justify-content-end'>
                                                    <div className='rating '>
                                                        <div><span style={{ fontSize: '13px' }} className="d-flex flex-column align-items-center justify-content-center"> <FaStar className='star' /> </span></div>
                                                        <div className="ff-poppins-semiBold"><span style={{ fontSize: '11px' }}> {data?.rating_detail?.rate_count}</span></div>
                                                    </div>
                                                </div>
                                                : <></>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="primary-text ff-poppins-semiBold fs-9 px-2 py-1 mt-2 w-100 secondary-bg-1 productStatus d-flex justify-content-between"  >

                    <div>
                        {
                            data?.delivery_status == "0" ?
                                <span>Order status - Unconfirmed</span>
                                : data?.delivery_status == "1" ?
                                    <span>Order status - Not Ready</span>
                                    : data?.delivery_status == "2" ?
                                        <span>Order status - Ready</span>
                                        : data?.delivery_status == "3" ?
                                            <span>Order status - pickup</span>
                                            : data?.delivery_status == "4" ?
                                                <span>Order status - Delivery Location Reached</span>
                                                : data?.delivery_status == "5" ?
                                                    <span>Order status - Product Delivered</span>
                                                    : <></>

                        }
                    </div>
                    <div>
                        {
                            data?.delivery_staff_status == true && data?.shipping_type == 2 ?
                                <span className="">Delivery staff : Assigned</span>
                                :
                                data?.delivery_staff_status == false && data?.shipping_type == 2 && data?.delivery_status != "0" ?
                                    <span className="text-dark">Delivery staff : Not Assigned</span>
                                    : <></>
                        }
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default AppointmentProductCard;

